import { Component } from '@angular/core';

@Component({
    selector: 'kiene-gruppenuebersicht',
    templateUrl: './gruppenuebersicht.component.html',
    styleUrls: ['./gruppenuebersicht.component.css'],
})
export class GruppenuebersichtComponent {
    constructor() {}
}
